import styled from 'styled-components';
import { TextBoxField } from '@agilepoint/wat-react-ux-form-fields';
import { StackPanel, Typography, typographyPresets } from '@agilepoint/wat-react-ux';

export const ElasticTextBoxField = styled(TextBoxField).attrs({
    gap: '4'
}) <{ $width?: string, $height?: string, $flexGrow?: string }>`
    width: ${({ $width }) => $width ?? '100%'};
    height: ${({ $height }) => $height};
    flex-grow: ${({ $flexGrow }) => $flexGrow};
    .ap-textbox-wrapper {
        padding-left: 15px;
        border-radius: 6px;
        border-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.genericBorderColor};
        .ap-textbox {
            font-size: 16px;
        }
        :hover, :focus-within, :active {
            border-color: ${({ theme }) => theme.semantics.palette.themePrimary};
        }
    }
    .ap-formField-errorMessage {
        ${typographyPresets.textStyles.small};
    }
`;

const SeparatorBlock = styled(Typography.Medium)`
    color: ${props => props.theme.toolbar.colors.separatorBackgroundColor};
`;

export function renderSeparator() {
    return <SeparatorBlock>| </SeparatorBlock>;
}

export const ElasticStackPanel = styled(StackPanel) <{ $width?: string; $height?: string }>`
   width: ${({ $width }) => $width}
   height: ${({ $height }) => $height}
`;
